export const boxStyles = { display: 'inline-flex', alignItems: 'center', gap: '4px' };

export const tooltipStyles = {
  padding: '24px',
  maxWidth: 'none',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const titleStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const titleHeadingStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 3,
};

export const tableContainerStyles = {
  overflowX: 'hidden',
  marginBottom: '12px',
  border: '1px solid',
  borderColor: ({ palette }) => palette.border.default,
  borderRadius: '8px',
};

export const rowCellStyles = {
  px: '15px',
  py: '4px',
  verticalAlign: 'top',
};

export const tableBodyStyles = {
  '& .table-row:last-of-type .table-cell': {
    borderBottom: 'none',
  },
};

export const footerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  padding: '12px',
};

export const footerAmountRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const footerNoteStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};
